import React from "react";

import ReportSummary from "./reports-summary/ReportsSummary";
import LayoutWithHeaderAndTabs from "layouts/LayoutHeaderTabs";

const Report = () => {
  let reportsTabs = [];

  reportsTabs.push({
    label: "Genel Özet",
    content: <ReportSummary />,
  });

  // reportsTabs.push({
  //   label: "Hakediş Analizleri",
  //   content: <ReportVehicles />,
  // });

  // reportsTabs.push({
  //   label: "Transfer Raporları",
  //   content: <ReportTransfers />,
  // });

  return (
    <LayoutWithHeaderAndTabs
      tabs={reportsTabs}
      layoutHeaderProps={{
        hideCreateNewItem: true,
        showSelectedYear: true,
      }}
    />
  );
};

export default Report;
